import {
  Button,
  Box,
  Stack,
  Text,
  Theme,
  SxProps,
} from '@ltvco/refresh-lib/theme';
import { nameize } from '@ltvco/refresh-lib/utils';

import { ReportChatCard } from 'components/ChatBV/components';
import {
  MessageReportData,
  PersonParamsFunctionArguments,
  PersonTeaserCondensedResult,
} from 'components/ChatBV/types';
import { renderMessageContent } from 'components/ChatBV/utils';

export const MessageContent = ({
  content,
  isHeader,
  isSticky,
  hasUserScrolled,
  handleButtonClick,
  handleChatTeaserClick,
  handleFiltersClick,
  handleViewAllResultsClick,
  handleFollowUpButtonClick,
  ContainerStyles,
  teaser,
  params,
  reports,
  messagePermalink,
  currentBvid,
  currentPermalink,
  reportOpen,
}: {
  content: string;
  isHeader: boolean;
  isSticky: boolean;
  hasUserScrolled: boolean;
  // eslint-disable-next-line no-unused-vars
  handleButtonClick: (report: MessageReportData) => void;
  // eslint-disable-next-line no-unused-vars
  handleChatTeaserClick: (bvid: string) => void;
  handleFiltersClick: () => void;
  handleViewAllResultsClick: () => void;
  handleFollowUpButtonClick: () => void;
  ContainerStyles?: SxProps<Theme>;
  teaser: PersonTeaserCondensedResult[] | undefined;
  params: PersonParamsFunctionArguments | undefined;
  reports: MessageReportData[] | undefined;
  messagePermalink: string | undefined;
  currentBvid: string | undefined;
  currentPermalink: string | undefined;
  reportOpen: boolean;
}) => {
  return (
    <Stack spacing={1} sx={ContainerStyles}>
      <Box>
        <Text
          variant={isHeader ? 'h1' : 'body1'}
          sx={{
            fontWeight: isHeader ? 600 : 400,
            color: 'text.primary',
            whiteSpace: 'pre-wrap',
            marginBottom: isHeader ? '0' : '20px',
            marginTop: isHeader ? '0' : '10px',
            lineHeight: 1.5,
            fontSize: isHeader
              ? isSticky && hasUserScrolled
                ? '24px !important'
                : '30px !important'
              : undefined,
            transition: isHeader ? 'font-size 0.3s ease-in-out' : undefined,
            '& *': {
              fontSize: 'inherit !important',
            },
          }}
        >
          {renderMessageContent(content)}
        </Text>
      </Box>
      {reports &&
        (reports.length === 1 ? (
          <Box>
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleButtonClick(reports[0])}
              disabled={currentPermalink === reports[0].permalink}
            >
              View full report
            </Button>
          </Box>
        ) : (
          <Box>
            {reports.map((report) => (
              <Button
                variant="outlined"
                size="small"
                onClick={() => handleButtonClick(report)}
                disabled={currentPermalink === report.permalink}
                key={report.permalink}
              >
                {nameize(report.type)}
              </Button>
            ))}
          </Box>
        ))}
      {params && (
        <Stack direction="row" spacing={1}>
          <Button
            variant="outlined"
            size="small"
            onClick={handleViewAllResultsClick}
            sx={{ textTransform: 'none', mt: 1 }}
          >
            View All Results
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={handleFiltersClick}
            sx={{ textTransform: 'none', mt: 1 }}
          >
            Filters
          </Button>
        </Stack>
      )}
      {teaser && (
        <Box>
          {teaser.map((item) => (
            <ReportChatCard
              title={item.name}
              reportType="person"
              clickAction={() => handleChatTeaserClick(item.bvid || '')}
              description={
                <Text color={'text.secondary'}>{item.currentLocation}</Text>
              }
              disabled={currentBvid === item.bvid && reportOpen}
              key={item.bvid}
            />
          ))}
        </Box>
      )}
      {messagePermalink && (
        <Box>
          <Button
            variant="outlined"
            size="small"
            onClick={handleFollowUpButtonClick}
            disabled={currentPermalink === messagePermalink}
          >
            View full report
          </Button>
        </Box>
      )}
    </Stack>
  );
};
